// frontend/src/services/api.js
import axios from 'axios';

// Determine the base URL based on the Node environment.
// process.env.NODE_ENV is automatically set by Create React App.
const baseURL = process.env.NODE_ENV === 'development'
    ? 'http://localhost:5000/api' // Use the full URL for local development (port 5002 from docker-compose.yml)
    : '/api';                     // Use a relative path for production (to be handled by Nginx)

// Create the axios instance with the dynamic baseURL.
const api = axios.create({
    baseURL: baseURL
});

// Export imageBaseUrl for use in other files (for serving images)
export const imageBaseUrl = process.env.REACT_APP_API_URL || '';

// Request Interceptor: Add the JWT token to every outgoing request.
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response Interceptor: Handle global errors, specifically for expired sessions.
api.interceptors.response.use(
    // 1. On a successful response, just return it.
    (response) => response,

    // 2. On an error response, check for 401 Unauthorized.
    (error) => {
        // Check if the error response exists and the status is 401
        if (error.response && error.response.status === 401) {
            // This indicates an invalid or expired token.

            // Remove the bad token from storage.
            localStorage.removeItem('token');

            // Force a hard redirect to the login page to clear all application state.
            // Exclude public pages so a stale token doesn't knock unauthenticated visitors off them.
            const publicPaths = ['/login', '/admission'];
            if (!publicPaths.includes(window.location.pathname)) {
                window.location.href = '/login';
            }
        }

        // For all other errors (e.g., 404, 500), let the component's .catch() block handle them.
        return Promise.reject(error);
    }
);

export default api;